import { Component, OnInit, Output, EventEmitter, Input, Renderer2, ElementRef, ViewChild, SimpleChanges, OnChanges } from '@angular/core';

@Component({
    selector: 'ui-alert',
    template:
    `   <div *ngIf="thumb" class="alert-thumb">
            <ng-content select="i"></ng-content>
            <ng-content select="img"></ng-content>
            <ng-content select="[alert-icon]"></ng-content>
        </div>
        <div class="alert-details">
            <ng-content></ng-content>
        </div>
        <div class="alert-actions" #alertActions>
            <ng-content select="button"></ng-content>
        </div>
        <button ui-button icon class="alert-close" (click)="dismiss()" *ngIf="dismissable"><span class="connect_icon_close"></span></button>
    `,
    styleUrls: ['./ui-alert.component.scss']
})
export class UiAlertComponent implements OnInit, OnChanges {

    // 'type' controleaza clasa alert-ului. posibile valori: danger, warning, primary, success
    @Input() type = 'default';
    @Input() thumb = false;

    // 'dismissable' controleaza interactivitatea alertei (daca poate fi inchisa sau nu), daca apare cu sau fara butonul de close
    // se poate adauga si button custom de dissmis apeland dismiss() on click, cu referinta pe alerta respectiva
    @Input() dismissable = false;

    // 'onDismiss' e eventul care se trigaruieste cand se inchide alerta
    @Output() onDismiss = new EventEmitter();

    @ViewChild('alertActions', {read: ElementRef, static: true}) actions: ElementRef;

    constructor(readonly renderer: Renderer2, readonly el: ElementRef) { }

    ngOnInit() {
        this.renderer.addClass(this.el.nativeElement, 'alert');
        this.renderer.addClass(this.el.nativeElement, this.type);

        // if no buttons are found in the alert actions wrapper, element will be removed (4 Bogdan)
        if (this.actions.nativeElement.childNodes.length === 0) {
            this.actions.nativeElement.remove();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.type && !changes.type.firstChange) {
            this.renderer.removeClass(this.el.nativeElement, changes.type.previousValue);
            this.renderer.addClass(this.el.nativeElement, changes.type.currentValue);
        }
    }

    dismiss() {
        this.onDismiss.emit(null);
    }
}
